import React, {
  useContext, useCallback, useEffect, useRef,
} from 'react';
import { Down } from '@icon-park/react';
import { observer } from 'mobx-react';
import Styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { toJS } from 'mobx';
import { DocsStore } from '../../models';
import { DocTreeSleleton } from '@/component/Skeleton';
import { isExpandTree } from '@/pages/document/utils';

let isTarget = false;

function DocMenu() {
  const { t } = useTranslation();
  const dragRef = useRef<HTMLDivElement>(null);
  const ref = useRef<HTMLDivElement>(null);
  const docsInfoStore = useContext(DocsStore);
  const { docsTree, docTreeStatus } = docsInfoStore;

  const onOpenChange = useCallback((id, index, expland) => {
    docsInfoStore.isClickNav = true;
    docsInfoStore.activeDocId = id;
    docsInfoStore.activeHash = '';
    const list = toJS(docsInfoStore.docsTree);
    docsInfoStore.docsTree = isExpandTree(list, index, expland);
    // 子Iframe 向父级传递变化信息
    window.parent.postMessage({ origin: 'doc_change', id }, '*');
    // golbalClickScroll(id);
    // setTimeout(() => { docsInfoStore.isClickNav = false; }, 500);
  }, []);

  // 全局文档的滚动点击事件
  // const golbalClickScroll = useCallback((id) => {
  //   if (docsInfoStore.viewType === 'GLOBAL') {
  //     const container = document.getElementById('doc_scroll_container');
  //     if (container) {
  //       const activeId = `global_header_${id}`;
  //       const { y } = (document.getElementById(activeId) as HTMLDivElement).getBoundingClientRect();
  //       const { scrollTop } = container;
  //       scrollTo({
  //         container,
  //         distance: scrollTop + y - 10,
  //       });
  //     }
  //   }
  // }, []);

  // 拖拽事件
  useEffect(() => {
    // 拖动
    (dragRef.current as HTMLDivElement).addEventListener('mousedown', (e) => {
      isTarget = true;
      e.preventDefault();
      document.getElementsByTagName('body')[0].style.cursor = 'col-resize';
      (dragRef.current as HTMLDivElement).classList.add('active');
    });
    document.addEventListener('mouseup', () => {
      isTarget = false;
      document.getElementsByTagName('body')[0].style.cursor = '';
      if (dragRef.current) {
        (dragRef.current as HTMLDivElement).classList.remove('active');
      }
    });
    document.addEventListener('mousemove', (e) => {
      if (isTarget) {
        (ref.current as any).style.width = `${e.pageX - 16}px`;
      }
    });
  }, []);

  const renderMenu = useCallback((list) => {
    // 无结果
    if ((!list || list.length === 0) && docTreeStatus !== 'loading') {
      return <div className={Styles.none}>{t('no_docs_list')}</div>;
    }

    const docList = toJS(list);
    return (<div className={Styles.inner}>{ docList.map((item: any, index: number) => renderLoop(item, String(index))) }</div>);

    function renderLoop(data: any, index: string) {
      const arr = index.split('-');
      const paddingLeft = `${arr.length * 20}px`;
      const hasChild = Boolean(data.childDocs) && Boolean(data.childDocs.length);
      const isActive = docsInfoStore.activeDocId === data.docId;

      const renderStyle = () => ({ paddingLeft, paddingRight: '25px', height: '40px' });

      return (
        <div key={index}>
          <div
            title={data.title}
            className={`${Styles.list} ${isActive && Styles.active}`}
            style={renderStyle()}
            onClick={() => {
              onOpenChange(data.docId, index, data.isExpand);
            }}
          >
            {data.title}
            {hasChild && <Down className={`${Styles.icon} ${data.isExpand && Styles.active}`} />}
          </div>
          <div className={`${Styles.innerContainer} ${data.isExpand && Styles.active}`}>
            {data.childDocs.map((item: any, key: number) => renderLoop(item, `${index}-${key}`))}
          </div>
        </div>
      );
    }
  }, []);

  return (
    <div className={Styles.container} ref={ref}>
      { docTreeStatus === 'loading' ? <DocTreeSleleton /> : renderMenu(docsTree) }
      <div ref={dragRef} className={Styles.drag} />
    </div>
  );
}

export default React.memo(observer(DocMenu));
